module.exports = __webpack_public_path__ + "static/media/applicant_agent.851b06cc.svg";